import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MainHeader } from '../MainHeader';
import { PhotoCollection } from '../PhotoCollection';
import { images } from './images';
import './styles.css';

export const Corporate = () => {
  useEffect(() => {
    document.title = "Rue's Events Designs - Corporate Events";
  }, []);

  return (
    <div className="collection-page">
      <MainHeader home={false} about={false} gallery={true} contact={false} />
      <section className="collection-hero">
        <p className="section-kicker">Rue's Events gallery</p>
        <h1>Corporate Events</h1>
        <p>Professional event environments created for organisations, teams, clients and special milestones.</p>
        <div className="collection-back-link">
          <Link to="/gallery">← Back to all collections</Link>
        </div>
      </section>
      <div className="collection-gallery-shell">
        <PhotoCollection images={images} label="Corporate Events" />
      </div>
    </div>
  );
};
